// extracted by mini-css-extract-plugin
module.exports = {"en72zbs":"en72zbs"};